import { useGetOrderNumbersQuery } from '@core/redux/query';
import { organizationManagementApiV1 as organizationManagementApi } from '@deepup/apis';

export function extractFlatMappings(data: organizationManagementApi.OrderNumber[]) {
  return data
    .flatMap((node) =>
      node.networkNodeMappings.map((mapping) => ({
        name: mapping.name,
        asb: mapping.asb,
        hkNumber: mapping.hkNumber,
        nvtNumber: mapping.nvtNumber,
        popNumber: mapping.popNumber,
        type: mapping.type,
        orderNumber: node.orderNumber,
      })),
    )
    .sort((a, b) => a.name.localeCompare(b.name));
}

export const useOrderNumbers = () => {
  const { data: orderNumbers, isLoading } = useGetOrderNumbersQuery();

  return { orderNumbers: orderNumbers || null, isLoading };
};
